<template>
  <i class="icon" 
    :class="[type ? type : 'main']"
    :style="mergeStyle" 
    @click="itemClicked(name)">{{Icon[name] || name}}</i>
</template>

<style scoped>
.icon {
    width: 1em;
    height: 1em;
    font-style: normal;
}
.main {
    color: #2f383c;
}
</style>

<script>
import Icon from './type';

export default {
    name: 'MideaIcon',
    props: {
      name: {
        default: '',
        type: String
      },
      size: {
        default: 'small',
        type: String
      },
      type: {
        default: '',
        type: String
      },
      iconStyle: {
        type: Object,
        default: () => ({})
      }
    },
    data: () => ({
      Icon
    }),
    computed: {
      mergeStyle () {
        const { iconStyle, size } = this;
        let fontSize = '13px';
        switch (size) {
          case 'xs':
            fontSize = '10px';
            break;
          case 'small':
            fontSize = '13px';
            break;
          case 'medium':
            fontSize = '16px';
            break;
          case 'big':
            fontSize = '20px';
            break;
          default:
            fontSize = '13px';
        }
        return {
          fontFamily: 'iconfontCommunity',
          fontSize,
          ...iconStyle
        }
      }
    },
    methods: {
      itemClicked (name) {
        this.$emit('click', {
          name
        });
      }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/Icon/index.vue